<template>
  <div>
    <div class="form-container">
      <ProgressBar :progressPercent="80" progressLabel="Step 4 of 5" />
      <h1 class="step-title">Security</h1>

      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="from-group security-checkboxes">
            <template
              v-for="value in [
                'Local Guards',
                'Central Alarm',
                'Local Alarm',
                'TV Circuit',
              ]"
            >
              <label :key="value">
                <input
                  type="checkbox"
                  @change="toggleSecurity(value)"
                  :checked="securities.includes(value)"
                />
                {{ value }}
              </label>
            </template>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="from-group security-checkboxes">
            <template
              v-for="value in [
                'Local Guards w TV Circuit',
                'Smoke Detectors',
                'Sprinklers',
                'Extinguishers',
              ]"
            >
              <label :key="value">
                <input
                  :key="value"
                  type="checkbox"
                  @change="toggleSecurity(value)"
                  :checked="securities.includes(value)"
                />
                {{ value }}
              </label>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="step-buttons">
      <button class="btn btn-primary" type="button" @click="prev()">
        Previous
      </button>
      <button class="btn btn-primary" type="button" @click="next()">
        Next
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ProgressBar from "./ProgressBar";

export default {
  components: { ProgressBar },
  computed: {
    ...mapState({
      securities: state => state.four.securities,
    }),
  },
  methods: {
    ...mapActions(["nextStep", "prevStep", "setSecurities"]),
    prev() {
      window.scrollTo(0, 0);
      this.prevStep();
    },
    next() {
      window.scrollTo(0, 0);
      this.nextStep();
    },
    toggleSecurity(val) {
      const { securities } = this;
      if (securities.includes(val)) {
        this.setSecurities(securities.filter(x => x != val));
      } else {
        this.setSecurities([...securities, val]);
      }
    },
  },
};
</script>

<style>
.security-checkboxes {
  display: flex;
  flex-direction: column;
}
</style>
